import { render, staticRenderFns } from "./MultipleItems.vue?vue&type=template&id=f96dbfd4"
import script from "./MultipleItems.vue?vue&type=script&lang=js"
export * from "./MultipleItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports